module.exports = "/assets/fireworks.png?D0M6ZfB";